<div
    class="labo-card"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h4>

        Labo
    </h4>
    <p>Informations sur le laboratoire</p>
    <form [formGroup]="editForm" (ngSubmit)="onEditSubmit()">
    <div class="row" *ngIf="laboratoryDetails">

        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Raison Sociale
                    </mat-label>
                    <input matInput formControlName="raisonSociale" value="{{laboratoryDetails.raisonSociale}}" >
                    <mat-error *ngIf="editForm.get('raisonSociale')?.hasError('required')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Capital
                    </mat-label>
                    <input formControlName="capital" type="number" matInput>
                    <mat-error *ngIf="editForm.get('capital')?.hasError('required')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        ICE
                    </mat-label>
                    <input matInput formControlName="ice" >
                    <mat-error *ngIf="editForm.get('ice')?.hasError('ice')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        IF
                    </mat-label>
                    <input matInput formControlName="i_f">
                    <mat-error *ngIf="editForm.get('ice')?.hasError('ice')">Champ obligatoire</mat-error>
                </mat-form-field>
            </div>
        </div>                

        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>

                        CNSS
                    </mat-label>
                    <input matInput formControlName="cnss">
                    <mat-error *ngIf="editForm.get('cnss')?.hasError('cnss')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Patente
                    </mat-label>
                    <input matInput formControlName="patente">
                    <mat-error *ngIf="editForm.get('patente')?.hasError('patente')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Téléphone
                    </mat-label>
                    <input matInput formControlName="telephone">
                    <mat-error *ngIf="editForm.get('telephone')?.hasError('telephone')">Champ obligatoire</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Fax
                    </mat-label>
                    <input matInput formControlName="fax">
                    <mat-error *ngIf="editForm.get('fax')?.hasError('fax')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Site web
                    </mat-label>
                    <input matInput formControlName="siteWeb">
                    <mat-error *ngIf="editForm.get('siteWeb')?.hasError('siteWeb')">Champ obligatoire</mat-error>
                </mat-form-field>
            </div>
        </div>               
        

        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        E-Mail
                    </mat-label>
                    <input matInput formControlName="adresseMail">
                    <mat-error *ngIf="editForm.get('adresseMail')?.hasError('adresseMail')">Champ obligatoire</mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <button mat-button 
                class="daxa mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base" >
                Mettre à jour
            </button>
        </div>
        
    </div>
    </form>

</div>